import { ActionDto } from "../maintenance/action/actionDto";

export class TruckingRouteActionConfirmDto {

	public action: ActionDto;
    public titleResource: string;
    public helpResource: string;


	static REMOVEROUTE(action: ActionDto): TruckingRouteActionConfirmDto {
		let result = new TruckingRouteActionConfirmDto();
		result.action = action;
		result.titleResource = "TRUCKING.ROUTE.ACTION.DIALOG.REMOVEROUTE.TITLE";
		result.helpResource = "TRUCKING.ROUTE.ACTION.DIALOG.REMOVEROUTE.HELP";
        return result;
    }

	static DESCONFIRMEDTRUCKING(action: ActionDto): TruckingRouteActionConfirmDto {
		let result = new TruckingRouteActionConfirmDto();
		result.action = action;
		result.titleResource = "TRUCKING.ROUTE.ACTION.DIALOG.DESCONFIRMEDTRUCKING.TITLE";
		result.helpResource = "TRUCKING.ROUTE.ACTION.DIALOG.DESCONFIRMEDTRUCKING.HELP";
        return result;
    }

	static UNBROKENROUTEFORCED(action: ActionDto): TruckingRouteActionConfirmDto {
		let result = new TruckingRouteActionConfirmDto();
		result.action = action;
		result.titleResource = "TRUCKING.ROUTE.ACTION.DIALOG.UNBROKENROUTEFORCED.TITLE";
		result.helpResource = "TRUCKING.ROUTE.ACTION.DIALOG.UNBROKENROUTEFORCED.HELP";
        return result;
    }
}
